export const listPath = [
    {
        name: 'Главная',
        path: '/',
    },
    {
        name: 'Кейсы',
        path: '/cases',
    },
    {
        name: 'Разработка',
        path: '/cases/development',
    },
];

export const listTitle = [
    {
        title: 'Разработка интерактивной highload-платформы для Международного киберфестиваля RUKAMI',
        description: [
            {
                name: 'Клиент',
                details: 'Технопарк «Сколково»',
            },
            {
                name: 'Отрасль',
                details: 'Технологии',
            },
            {
                name: 'Технологии',
                details:
                    'Kubernetes, Laravel Framework, React, Sass, Node.js, PHP, SSR, TypeScript, Mobx, Socket.io, MySQL, Redis, GitlabCI, PWA',
            },
        ],
    },
];
